import { render } from "./CDataTable.vue?vue&type=template&id=c0d816ee&scoped=true"
import script from "./CDataTable.vue?vue&type=script&lang=js"
export * from "./CDataTable.vue?vue&type=script&lang=js"

import "./CDataTable.vue?vue&type=style&index=0&id=c0d816ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0d816ee"]])

export default __exports__